import { Panels } from "@msuite/ui/panels";
import { ThirdPartyIntegrationCard } from "@/components/cards/third-party-integration-card";

export function OrganizationSettingsIntegrations() {
	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<div className="w-full aspect-video stripes card" />
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<div className="v-stack p-1">
					<ThirdPartyIntegrationCard integrationType="personio" />
					<ThirdPartyIntegrationCard integrationType="webfleet" />
				</div>
			</Panels.Panel>
		</Panels>
	);
}
